import React, {Component} from 'react';
import NavBar from './components/Header/NavBar'
import {Router,Route,Link,Redirect} from "react-router-dom";
import Footer from './components/Footer/Footer'
import Login from './components/Signin/Login'
import Signup from './components/Signup/Signup'
import SignIn from './components/Signin/SignIn'
import Register from './components/Signup/Register'
import ConnectList from './components/News/NewsList'
import Profile from './components/Users/Profile'
import Account from './components/Users/Account'
import SingleNews from './components/News/SingleNews'
import SingleEvent from './components/Events/SingleEvent'
import EventList from './components/Events/EventList'
import TutorialList from './components/Tutorials/TutorialList'
import SingleTutorial from './components/Tutorials/SingleTutorial'
import ContactPage from './components/Contact/ContactPage'
import Main from './components/Home/Main'
import './App.css';
import Auth from './Auth/Auth';
import history from './History';
import RegisterLead from './components/CreateLead/LeadForm'
import EditLead from './components/CreateLead/Edit'
const auth = new Auth();

const handleAuthentication = ({
    location
  }) => {
    if (/access_token|id_token|error/.test(location.hash)) {
      auth.handleAuthentication();
    }
}

const App = () => {
  return (
    <Router history={history}>
          <div>
          <NavBar />
            <Route exact path="/" render={(props) => <Main auth={auth} {...props} />} />
            <Route path="/articles" component={ConnectList} />
            <Route path="/register" component={Register} />
            <Route path="/createlead" component={RegisterLead} />
            <Route path="/editlead" component={EditLead} />
            <Route path="/projects" component={EventList} />
            <Route path="/login" component={Login} />
            <Route path="/signin" component={SignIn} />
            <Route path="/signup" component={Signup} />
            <Route path="/articledetails/:slug" component={SingleNews} />
            <Route path="/eventdetails/:slug" component={SingleEvent} />
            <Route path="/profile" component={Profile} />
            <Route path="/account" component={Account} />
            <Route path="/contact" component={ContactPage} />
            <Route path="/tutorials" component={TutorialList} />
            <Route path="/tutorialdetails/:slug" component={SingleTutorial} />
            <Footer />
        
          </div>
    </Router>
  );
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js